import { useEffect } from 'react';
import { getCandidateJobBoardProfile } from 'wisestep-api';

import { useConversationWidgetStore } from '../../../utils/useConversationWidgetStore';

const CandidateJobBoardProfile = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const openModal = useConversationWidgetStore((state) => state.setCandidate);
  const setIsNativeSearch = useConversationWidgetStore((state) => state.setIsNativeSearch);
  const source = queryParameters.get('source');
  const candidateJobBoardId = queryParameters.get('candidateJobBoardId');

  useEffect(() => {
    (async () => {
      if (source != null && candidateJobBoardId != null) {
        const res = await getCandidateJobBoardProfile(source, candidateJobBoardId);
        setIsNativeSearch(true);
        openModal(res.data);
      }
    })();
  }, [candidateJobBoardId, openModal, setIsNativeSearch, source]);

  return <></>;
};

export default CandidateJobBoardProfile;
